import React from 'react';
import { Box, useWidth } from 'vindi-ds-components';
import styles from './styles';
import mobileStyles from './mobile/styles';

function TopImage({ image, altText }) {
  const breakpoint = useWidth();
  let stylesCss = styles;

  if (['xs', 'sm'].includes(breakpoint)) {
    stylesCss = mobileStyles;
  }
  return (
    <Box css={stylesCss.image}>
      <img src={image} alt={altText} style={stylesCss.imageMobile} />
    </Box>
  );
}

export default TopImage;
